"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledHr = _styledComponents.default.hr`
  ${_styledSystem.margin}
  width: inherit;
  border: 0;
  height: 1px;
  background: ${({
  theme
}) => theme.hr.background};
`;
StyledHr.defaultProps = {
  theme: _base.default
};
var _default = StyledHr;
exports.default = _default;